<template>
  <f7-page id="axsr-reg-success" name="axsr-reg-success" @page:beforein="init()" @page:afterin="afterin" class="bg-color-white">
    <div class="content text-align-center">
      <img :src="require('@/assets/img/icon/icon-success.svg')"/>
      <div class="wandr-title-1 text-align-center mt-lg" v-html="titleText"></div>
    </div>

    <f7-toolbar position="bottom" no-hairline class="toolbar-with-button">
      <f7-button large fill @click="goRedirectionPage">
          {{$t('general-text-continue')}}
      </f7-button>
    </f7-toolbar>
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  

  export default {
    mounted (){
      this.titleText = this.$t('axs-register-success')
    },
    data() {
      return {
        titleText           : "",
      };
    },
    methods: {
      ...mapActions('registration', [
      
      ]),

      init(){

      },

      afterin(){

      },

      goRedirectionPage(){
        console.log("goRedirectionPage")
        this.$f7router.navigate("/axsr-register-redirect");
      },
    },
    components: {
      
    },
    computed: {
      ...mapGetters('registration', [
        
      ]),
    },
  }
</script>